import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { resolveUrl } from "@/lib/api";

const SLIDE = { duration: 0.24, ease: [0.22, 1, 0.36, 1] };
const SWIPE_THRESHOLD = 58;

export const SegmentSlider = ({ items = [], index, direction, onChange, label, testid, prevTestid, nextTestid }) => {
  const item = items[index];
  const itemKey = item?.id || item?.slot || item?.slot_number || item?.asset_url || index;

  const handleDragEnd = (_, info) => {
    if (info.offset.x <= -SWIPE_THRESHOLD) onChange(1);
    else if (info.offset.x >= SWIPE_THRESHOLD) onChange(-1);
  };

  return (
    <div
      className="segment-zone relative"
      data-testid={testid}
      data-segment-label={label}
      role="group"
      aria-label={`${label}: ${item?.name || ""}`}
    >
      <div className="segment-viewport">
        <AnimatePresence initial={false} mode="sync" custom={direction}>
          <motion.div
            key={itemKey}
            custom={direction}
            className="segment-motion-layer"
            initial={{ x: direction > 0 ? "100%" : "-100%" }}
            animate={{ x: "0%" }}
            exit={{ x: direction > 0 ? "-100%" : "100%" }}
            transition={SLIDE}
            drag="x"
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={0.12}
            dragMomentum={false}
            onDragEnd={handleDragEnd}
          >
            <img
              src={resolveUrl(item?.asset_url)}
              alt={item?.name || label}
              className="segment-img"
              draggable={false}
            />
          </motion.div>
        </AnimatePresence>
      </div>

      <button
        type="button"
        aria-label={`${label} zurück`}
        data-testid={prevTestid}
        onClick={() => onChange(-1)}
        className="arrow-btn absolute left-1.5 top-1/2 -translate-y-1/2 z-10 h-9 w-9 rounded-full flex items-center justify-center"
      >
        <ChevronLeft size={18} />
      </button>
      <button
        type="button"
        aria-label={`${label} weiter`}
        data-testid={nextTestid}
        onClick={() => onChange(1)}
        className="arrow-btn absolute right-1.5 top-1/2 -translate-y-1/2 z-10 h-9 w-9 rounded-full flex items-center justify-center"
      >
        <ChevronRight size={18} />
      </button>
    </div>
  );
};

export default SegmentSlider;
